import component from './ca-ES/component';
import globalHeader from './ca-ES/globalHeader';
import menu from './ca-ES/menu';
import pages from './ca-ES/pages';
import pwa from './ca-ES/pwa';
import settingDrawer from './ca-ES/settingDrawer';
import settings from './ca-ES/settings';
import fixOverlay from './ca-ES/fix_overlay';
import fixOpenapi from './ca-ES/fix_openapi';
import fixAdminMisc from './ca-ES/fix_adminmisc';
import fixBilling from './ca-ES/fix_billing';
import fixComponents from './ca-ES/fix_components';
import fixConsoleMisc from './ca-ES/fix_consolemisc';
import fixGap from './ca-ES/fix_gap';
import fixSystemconfig from './ca-ES/fix_systemconfig';
import fixTenant from './ca-ES/fix_tenant';
import fixVoiceClone from './ca-ES/fix_voiceclone';
import fixTodo from './ca-ES/fix_todo';
import fixLedger from './ca-ES/fix_ledger';


export default {
  'navBar.lang': 'Lleng��es',
  'layout.user.link.help': 'Ajuda',
  'layout.user.link.privacy': 'Privacitat',
  'layout.user.link.terms': 'Termes',
  'app.preview.down.block': 'Descarrega aquesta p��gina al teu projecte local',
  'app.welcome.link.fetch-blocks': 'Obtenir tots els blocs',
  'app.welcome.link.block-list':
    'Construeix r��pidament p��gines est��ndard basades en el desenvolupament de blocs',
  ...fixConsoleMisc,
  ...fixComponents,
  ...fixAdminMisc,
  ...fixBilling,
  ...fixTenant,
  ...fixVoiceClone,
  ...fixGap,
  ...fixSystemconfig,
  ...fixOpenapi,
  ...fixTodo,
  ...fixLedger,
};
